<template>
  <img :src="imagePath" class="statusIcon" :alt="imageText" :title="imageText"/>
</template>

<script>
export default {
  props: {
    statusId: {
      default: 0
    }
  },
  data () {
    return {
      imageText: ''
    }
  },
  computed: {
    imagePath: {
      get: function () {
        return this.getImagePath(this.statusId)
      },
      set: function (modifiedValue) {
        this.getImagePath(modifiedValue)
      }
    }
  },
  methods: {
    getImagePath (stId) {
      var path = ''
      switch (stId) {
        case 1:
        case 5:
        case 12:
          path = require('@/assets/status/in-preparation.svg')
          this.imageText = 'In Preparation'
          break
        case 7:
          path = require('@/assets/status/approved.svg')
          this.imageText = 'Approved'
          break
        case 10:
          path = require('@/assets/status/cancelled.svg')
          this.imageText = 'Cancelled'
          break
        case 4:
          path = require('@/assets/status/completed.svg')
          this.imageText = 'Completed'
          break
        case 9:
          path = require('@/assets/status/denied-with-conditions.svg')
          this.imageText = 'Denied with Conditions'
          break
        case 8:
          path = require('@/assets/status/denied.svg')
          this.imageText = 'Denied'
          break
        case 2:
        case 6:
          path = require('@/assets/status/raised.svg')
          this.imageText = 'Raised'
          break
        case 3:
          path = require('@/assets/status/partially-approved.svg')
          this.imageText = 'Partially Approved'
          break
        case 11:
          path = require('@/assets/status/withdrawn.svg')
          this.imageText = 'Withdrawn'
          break
        default:
          path = require('@/assets/status/in-preparation.svg')
          this.imageText = 'In Preparation'
          break
      }
      return path
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .statusIcon {
    width: 27px;
    height: 27px;
  }
</style>
